if ( typeof customElements.get('active-promotion-banner') === 'undefined' ) {

	const ACTIVE_PROMOTION_STORAGE_KEY = 'ffm-active-promotion-v1';
	const ACTIVE_PROMOTION_PARAMETER = 'ff_promo';
	const ACTIVE_PROMOTION_TTL = 24 * 60 * 60 * 1000;

	const ACTIVE_PROMOTIONS = Object.freeze({
		FFMETA20: Object.freeze({
			promoKey: 'FFMETA20',
			discountCode: 'FFMETA20',
			source: 'Meta',
			badge: '$20 OFF',
			message: 'Your first order discount is saved for checkout.'
		}),
		FFMG20: Object.freeze({
			promoKey: 'FFMG20',
			discountCode: 'FFMG20',
			source: 'Google Ads',
			badge: '$20 OFF',
			message: 'Your first order discount is saved for checkout.'
		}),
		FFMETASUB20: Object.freeze({
			promoKey: 'FFMETASUB20',
			discountCode: 'FFMETASUB20',
			source: 'Meta',
			badge: '20% OFF',
			message: 'Your first subscription discount is saved for checkout.'
		}),
		FFMGSUB20: Object.freeze({
			promoKey: 'FFMGSUB20',
			discountCode: 'FFMETASUB20',
			source: 'Google Ads',
			badge: '20% OFF',
			message: 'Your first subscription discount is saved for checkout.'
		}),
		FFMETASUB40: Object.freeze({
			promoKey: 'FFMETASUB40',
			discountCode: 'FFMETASUB40',
			source: 'Meta',
			badge: '40% OFF',
			message: 'Your first Commit to Healthy offer is saved for checkout.'
		}),
		FFMGSUB40: Object.freeze({
			promoKey: 'FFMGSUB40',
			discountCode: 'FFMETASUB40',
			source: 'Google Ads',
			badge: '40% OFF',
			message: 'Your first Commit to Healthy offer is saved for checkout.'
		}),
		BUY6GET6: Object.freeze({
			promoKey: 'BUY6GET6',
			discountCode: 'BUY6GET6',
			source: 'Shared',
			badge: 'BUY 6 GET 6',
			message: 'Your Buy 6, Get 6 offer is saved for checkout.'
		})
	});

	const getPromotion = promoKey => {
		if (
			typeof promoKey !== 'string'
			|| ! Object.prototype.hasOwnProperty.call(ACTIVE_PROMOTIONS, promoKey)
		) {
			return null;
		}

		return ACTIVE_PROMOTIONS[promoKey];
	};

	const getSafeReturnUrl = value => {
		if ( typeof value !== 'string' || value.length === 0 ) return null;

		try {
			const url = new URL(value, window.location.origin);
			if (
				url.origin !== window.location.origin
				|| ! url.pathname.startsWith('/')
				|| url.pathname.startsWith('//')
			) {
				return null;
			}

			url.searchParams.delete(ACTIVE_PROMOTION_PARAMETER);
			const search = url.searchParams.toString();
			return `${url.pathname}${search ? `?${search}` : ''}${url.hash}`;
		} catch(e) {
			return null;
		}
	};

	const getComparableStorefrontUrl = value => {
		const safeReturnUrl = getSafeReturnUrl(value);
		if ( ! safeReturnUrl ) return null;

		const url = new URL(safeReturnUrl, window.location.origin);
		const pathname = url.pathname === '/' ? '/' : url.pathname.replace(/\/+$/, '');
		url.searchParams.sort();
		const search = url.searchParams.toString();

		return `${pathname}${search ? `?${search}` : ''}`;
	};

	const isCurrentReturnUrl = returnUrl => {
		const comparableReturnUrl = getComparableStorefrontUrl(returnUrl);
		const comparableCurrentUrl = getComparableStorefrontUrl(window.location.href);

		return comparableReturnUrl !== null && comparableReturnUrl === comparableCurrentUrl;
	};

	const removeStoredPromotion = () => {
		try {
			localStorage.removeItem(ACTIVE_PROMOTION_STORAGE_KEY);
		} catch(e) {}
	};

	const readStoredPromotion = () => {
		try {
			const storedPromotion = JSON.parse(localStorage.getItem(ACTIVE_PROMOTION_STORAGE_KEY));
			const currentTime = Date.now();
			const storedPromoKey = storedPromotion?.promoKey || storedPromotion?.code;
			const promotion = getPromotion(storedPromoKey);
			const isValid = storedPromotion
				&& promotion
				&& Number.isFinite(storedPromotion.activatedAt)
				&& Number.isFinite(storedPromotion.expiresAt)
				&& typeof storedPromotion.dismissed === 'boolean'
				&& storedPromotion.activatedAt > 0
				&& storedPromotion.activatedAt <= currentTime
				&& storedPromotion.expiresAt - storedPromotion.activatedAt === ACTIVE_PROMOTION_TTL
				&& storedPromotion.expiresAt > currentTime;

			if ( ! isValid ) {
				removeStoredPromotion();
				return null;
			}

			return {
				promoKey: promotion.promoKey,
				discountCode: promotion.discountCode,
				source: promotion.source,
				activatedAt: storedPromotion.activatedAt,
				expiresAt: storedPromotion.expiresAt,
				dismissed: storedPromotion.dismissed,
				returnUrl: getSafeReturnUrl(storedPromotion.returnUrl)
			};
		} catch(e) {
			removeStoredPromotion();
			return null;
		}
	};

	const writeStoredPromotion = promotion => {
		try {
			localStorage.setItem(ACTIVE_PROMOTION_STORAGE_KEY, JSON.stringify(promotion));
		} catch(e) {}
	};

	const removePromotionParameter = url => {
		url.searchParams.delete(ACTIVE_PROMOTION_PARAMETER);
		const search = url.searchParams.toString();
		const cleanUrl = `${url.pathname}${search ? `?${search}` : ''}${url.hash}`;

		try {
			history.replaceState(history.state, '', cleanUrl);
		} catch(e) {}

		return cleanUrl;
	};

	let activePromotionState = null;
	let activePromotionResolved = false;
	let activePromotionExpirationTimer = null;

	const scheduleActivePromotionExpiration = promotionState => {
		if ( activePromotionExpirationTimer !== null ) {
			window.clearTimeout(activePromotionExpirationTimer);
			activePromotionExpirationTimer = null;
		}

		if ( ! promotionState ) return;

		activePromotionExpirationTimer = window.setTimeout(() => {
			activePromotionExpirationTimer = null;

			if ( ! activePromotionState ) return;
			if ( activePromotionState.expiresAt > Date.now() ) {
				scheduleActivePromotionExpiration(activePromotionState);
				return;
			}

			activePromotionState = null;
			removeStoredPromotion();
			renderConnectedPromotionBanners();
		}, Math.max(0, promotionState.expiresAt - Date.now()));
	};

	const resolveActivePromotion = () => {
		if ( activePromotionResolved ) {
			return activePromotionState;
		}

		activePromotionResolved = true;
		activePromotionState = readStoredPromotion();

		const url = new URL(window.location.href);
		if ( url.searchParams.has(ACTIVE_PROMOTION_PARAMETER) ) {
			const requestedPromoKey = url.searchParams.get(ACTIVE_PROMOTION_PARAMETER);
			const promotion = getPromotion(requestedPromoKey);
			const returnUrl = getSafeReturnUrl(removePromotionParameter(url));

			if ( promotion ) {
				const activatedAt = Date.now();
				activePromotionState = {
					promoKey: promotion.promoKey,
					discountCode: promotion.discountCode,
					source: promotion.source,
					activatedAt,
					expiresAt: activatedAt + ACTIVE_PROMOTION_TTL,
					dismissed: false,
					returnUrl
				};
				writeStoredPromotion(activePromotionState);
			}
		}

		scheduleActivePromotionExpiration(activePromotionState);

		return activePromotionState;
	};

	const connectedPromotionBanners = new Set();

	const renderConnectedPromotionBanners = () => {
		const promotionState = resolveActivePromotion();
		let promotionRendered = false;

		connectedPromotionBanners.forEach(banner => {
			if ( promotionState && ! promotionState.dismissed && ! promotionRendered ) {
				banner.showPromotion(promotionState, getPromotion(promotionState.promoKey));
				promotionRendered = true;
			} else {
				banner.hidePromotion();
			}
		});
	};

	const connectPromotionBanner = banner => {
		connectedPromotionBanners.add(banner);
		renderConnectedPromotionBanners();
	};

	const disconnectPromotionBanner = banner => {
		connectedPromotionBanners.delete(banner);
		renderConnectedPromotionBanners();
	};

	const dismissActivePromotion = promoKey => {
		const promotionState = resolveActivePromotion();
		if ( ! promotionState || promotionState.promoKey !== promoKey ) {
			return;
		}

		activePromotionState = {
			...promotionState,
			dismissed: true
		};
		writeStoredPromotion(activePromotionState);
		renderConnectedPromotionBanners();
	};

	class ActivePromotionBanner extends HTMLElement {

		constructor() {
			super();
			this._connected = false;
			this._dismissHandler = this.#dismiss.bind(this);
		}

		connectedCallback() {
			if ( this._connected ) return;
			this._connected = true;

			this._message = this.querySelector('[data-active-promotion-message]');
			this._badge = this.querySelector('[data-active-promotion-badge]');
			this._discountCode = this.querySelector('[data-active-promotion-code-text]');
			this._returnLink = this.querySelector('[data-active-promotion-return]');
			this._dismissButton = this.querySelector('[data-active-promotion-dismiss]');
			if ( ! this._message || ! this._dismissButton ) return;

			this._dismissButton.addEventListener('click', this._dismissHandler);
			connectPromotionBanner(this);
		}

		disconnectedCallback() {
			if ( ! this._connected ) return;
			this._dismissButton?.removeEventListener('click', this._dismissHandler);
			disconnectPromotionBanner(this);
			this._connected = false;
		}

		showPromotion(promotionState, promotion) {
			const promoKey = promotionState.promoKey;
			const returnUrl = getSafeReturnUrl(promotionState.returnUrl);

			this.dataset.activePromotionKey = promoKey;
			this.hidden = false;
			this._message.textContent = promotion.message;
			if ( this._badge ) {
				this._badge.textContent = promotion.badge;
			}
			if ( this._discountCode ) {
				this._discountCode.textContent = promotion.discountCode;
			}
			if ( this._returnLink ) {
				if ( returnUrl && ! isCurrentReturnUrl(returnUrl) ) {
					this._returnLink.setAttribute('href', returnUrl);
					this._returnLink.hidden = false;
				} else {
					this._returnLink.hidden = true;
					this._returnLink.removeAttribute('href');
				}
			}
		}

		hidePromotion() {
			this.hidden = true;
			this.removeAttribute('data-active-promotion-key');
			if ( this._message ) {
				this._message.textContent = '';
			}
			if ( this._badge ) {
				this._badge.textContent = '';
			}
			if ( this._discountCode ) {
				this._discountCode.textContent = '';
			}
			if ( this._returnLink ) {
				this._returnLink.hidden = true;
				this._returnLink.removeAttribute('href');
			}
		}

		#dismiss() {
			if ( this.dataset.activePromotionKey ) {
				dismissActivePromotion(this.dataset.activePromotionKey);
			}
		}

	}

	customElements.define('active-promotion-banner', ActivePromotionBanner);

}
